<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.fullName" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="username" label="用户名" align="center">
				</el-table-column>
				<el-table-column prop="fullName" label="昵称" align="center">
				</el-table-column>
				<el-table-column prop="tel" label="管理员电话" align="center">
				</el-table-column>
				<el-table-column prop="roleName" label="角色类型" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="warning" @click="reset(scope.row)">重置密码</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="用户名" label-width='100px'>
					<el-input v-model="form.username" maxlength="18" autocomplete="off" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="昵称" label-width='100px'>
					<el-input v-model="form.fullName" maxlength="10" autocomplete="off" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item label="密码" label-width='100px'>
					<el-input v-model="form.password" type="password" maxlength="18" autocomplete="off" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item label="电话" label-width='100px'>
					<el-input v-model.number="form.tel" maxlength="11" autocomplete="off" placeholder="请输入电话号码"></el-input>
				</el-form-item>
				<el-form-item label="角色类型" label-width='100px'>
					<el-select v-model="form.roleId" placeholder="请选择">
						<el-option v-for="item in roleOptions" :key="item.pkRoleId" :label="item.roleName"
							:value="item.pkRoleId">
						</el-option>
					</el-select>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				roleOptions: [],
				selectTableData: [],
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				secah: {
					pageSize: 10,
					pageNum: 1,
					fullName: ""
				},
				form: {
					pkUserId:"",
					password: "",
					roleId: "",
					tel: "",
					username: "",
					enableStatus: 1,
					fullName:""
				},

			}
		},
		created() {
			this.getUserList()
			this.getRoleList()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getUserList()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form={
					pkUserId:"",
					password: "",
					roleId: "",
					tel: "",
					username: "",
					enableStatus: 1,
					fullName:""
				}
			},
			//提交
			sub(){
				if (this.form.username.length == 0) {
					this.$message('请输入用户名');
					return false
				}
				if (this.form.fullName.length == 0) {
					this.$message('请输入昵称');
					return false
				}
				if (this.form.password.length <6) {
					this.$message('请输入正确的密码');
					return false
				}
				if (!this.isTel(this.form.tel)) {
					this.$message('请输入正确的电话号码');
					return false
				}
				
				if (this.form.roleId.length == 0) {
					this.$message('请选择角色类型');
					return false
				}
				var url=this.isAdd?"/system/user/add":"/system/user/update"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getUserList()
						}
					})
				}else{
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getUserList()
						}
					})
				}
				
			},
			
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/system/user/del?"+this.$qs.stringify({pkUserId:row.pkUserId})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getUserList()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form=JSON.parse(JSON.stringify(row))
				// this.form.password=''
				
			},
			//重置密码
			reset(row){
				var obj={pkUserId:row.pkUserId}
				this.httpPut('/system/user/resetPassword',this.$qs.stringify(obj)).then(res => {
					if (res.code == 200) {
						this.$message.success('重置成功');
					}
				})
			},

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getUserList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getUserList()
			},
			//获取数据
			getUserList() {
				this.httpPost("/system/user/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},
			//获取角色数据
			getRoleList() {
				this.httpPost("/system/role/allList", this.secah).then(res => {
					if (res.code == 200) {
						this.roleOptions = res.data
					}
				})
			}

		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
